import { Advertisement } from './Advertisement';
import { Announcement } from './Announcement';
import { Category } from './Category';
import { Media } from './Media';
import { Post } from './Post';
import { Topic } from './Topic';

export enum FeaturedBannerType {
  POST = 'post',
  CATEGORY = 'category',
  SUB_CATEGORY = 'sub-category',
  TOPIC = 'topic',
  ADVERTISEMENT = 'advertisement',
  ANNOUNCEMENT = 'announcement',
}

export type FeaturedBanner = {
  id: string;
  post?: Post;
  category?: Category;
  subCategory?: Category;
  topic?: Topic;
  media?: Media;
  announcement?: Announcement;
  advertisement?: Advertisement;
  type: FeaturedBannerType;
};
